import React, { useEffect, useState } from "react"
import { showSnackBar } from "../Snackbar/Snackbar"
import { getPaymentsReceived } from "../../features/payment/paymentSlice"
import { useDispatch } from "react-redux"
import { useMyContextLoading } from "../LoadingContextProvider/LoadingContextProvider"
import { useParams } from "react-router-dom"
import TableList from "./TableList"

const Transactions = ({ userRole }) => {
  const dispatch = useDispatch()
  const { contactId } = useParams()
  const [paymentsReceived, setPaymentsReceived] = useState([])
  const [reqError, setReqError] = useState('')
  const { triggerLoading } = useMyContextLoading()

  useEffect(() => {
    const handleReqError = () => {
      reqError?.length > 0 && showSnackBar("error", reqError)
      setReqError('')
    }

    handleReqError()
  }, [reqError])


  const getUsersPaymentsReceived = async () => {
    triggerLoading(true)
    try {
      let result = await dispatch(getPaymentsReceived(contactId))
      if (result?.payload?.data && result.payload?.data?.length > 0) {
        setPaymentsReceived(result.payload.data)
      } else {
        setPaymentsReceived([])
      }
    } catch (error) {
      setReqError(error)
    }
    triggerLoading(false)
  }

  useEffect(() => {
    getUsersPaymentsReceived()
  }, [])


  return (
    <div className="flex flex-col w-full">
      <TableList triggerUpdate={(e) => {
        e && getUsersPaymentsReceived()
      }} data={paymentsReceived} userRole={userRole}/>
    </div>
  )
}
export default Transactions
